import { useEffect } from "react"
import FadeDialog from "../../components/FadeDialog"
import Arrows from "../../components/Icons/navy_double_arrow_left.svg"
import {
  Holder,
  Title,
  Label,
  LightHolder,
  LightBgHolder,
  LightPH,
  DarkHolder,
  DarkBgHolder,
  DarkPH,
  Label1,
  Title1,
  BackButton,
  BackIcon,
  DialogContent
} from "./ShowApartment.style.js"

import { Data } from "./ShowApartment.data"
import PanoViewer from "../../components/PanoViewer/PanoViewer"
import { useStore } from "../../state/store"

const pageVariants = {
  initial: {
    opacity: 0
  },
  in: {
    opacity: 1
  },
  out: {
    opacity: 0
  }
}

const pageTransition = {
  type: "spring",
  stiffness: 150,
  damping: 50,
  mass: 1.2
}

export default function ShowApartment() {
  const activeCard = useStore(state => state.activeCard)
  const setActiveCard = useStore(state => state.setActiveCard)
  // console.log(activeCard)

  const showPano = useStore(state => state.showPano)
  const setShowPano = useStore(state => state.setShowPano)

  const openDlg = useStore(state => state.openDlg)
  const setOpenDlg = useStore(state => state.setOpenDlg)

  useEffect(() => {
    return () => {
      setOpenDlg(false)
      setShowPano(false)
    }
  }, [])

  const handleBack = () => {
    if (openDlg) {
      setOpenDlg(false)
    }
  }
  const handlePHClick = type => {
    setActiveCard(Data[type])
    setOpenDlg(true)

    setTimeout(() => {
      setShowPano(true)
    }, 1600)
  }

  return (
    <>
      <Holder
        initial="initial"
        animate="in"
        exit="out"
        variants={pageVariants}
        transition={pageTransition}
      >
        <LightHolder>
          <LightBgHolder>
            <Title color="#ffffff">West</Title>
            <Label color="#5F7774">ONE BED APARTMENT</Label>
          </LightBgHolder>
          <LightPH
            onClick={() => {
              handlePHClick("light")
            }}
          />
        </LightHolder>
        <DarkHolder>
          <DarkBgHolder>
            <Label1 color="#97B5B1">ONE BED APARTMENT</Label1>
            <Title1 color="#ffffff">East</Title1>
          </DarkBgHolder>
          <DarkPH
            onClick={() => {
              handlePHClick("dark")
            }}
          />
        </DarkHolder>
      </Holder>
      <FadeDialog show={openDlg}>
        <DialogContent>
          {showPano && activeCard && <PanoViewer data={activeCard} />}
          <BackButton onClick={handleBack}>
            <BackIcon src={Arrows} />
          </BackButton>
        </DialogContent>
      </FadeDialog>
    </>
  )
}
